export default "<div>\n  <iframe #e [style.height.px]=\"getHtmlHeight()\" [srcdoc]=\"data?.htmlContent | safeHtml\"></iframe>\n</div>"